import React from 'react';
import AdminDynamicTable from '../components/common/Tables/AdminDynamicTable';


export const InstallationTypes = ({
  client
 }) => {
    return (
        <div className="installation-types">
            <AdminDynamicTable
                client={client}
                url="installation_types"
                title="Installation Types"
                excludeHeaderFields={['id', 'created_date', 'updated_date']}
                excludeEditFields={['id', 'created_date', 'updated_date']}
                readOnly={[1]}
            />
        </div>
    );
};

export default InstallationTypes;


// WEBPACK FOOTER //
// ./src/pages/InstallationTypes.jsx